import React, { useEffect } from 'react'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const GalleryReveal: React.FC = () => {
	useEffect(() => {
		gsap.registerPlugin(ScrollTrigger)

		let container = document.querySelector('.gallery-reveal--container') as HTMLDivElement

		let ctx = gsap.context(() => {
			// FIRST REVEAL
			gsap.timeline({
				scrollTrigger: {
					trigger: container,
					start: 'top bottom',
					scrub: 1.5,
					invalidateOnRefresh: true,
					end: 'bottom center',
					// markers: true,
				},
			})
				.add('reveal-stage-1')
				.fromTo(
					'.reveal-left',
					{
						xPercent: 0,
						ease: 'none',
					},
					{
						xPercent: container.offsetWidth > 700 ? -75 : -110,
					},
					'reveal-stage-1'
				)
				.fromTo(
					'.reveal-right',
					{
						xPercent: 0,
						ease: 'none',
					},
					{
						xPercent: container.offsetWidth > 700 ? 75 : 110,
					},
					'reveal-stage-1'
				)

			// SECOND STAGE OF REVEAL
			gsap.timeline({
				immediateRender: false,
				scrollTrigger: {
					trigger: container,
					start: 'top top',
					pin: true,
					scrub: 1.5,
					invalidateOnRefresh: true,
					end: '+=300',
				},
			}).to('.gallery-reveal--sub-container', {
				yPercent: -10,
				ease: 'none',
			})
		})

		return () => ctx.revert()
	}, [])

	return (
		<div className='gallery-reveal--container'>
			<div className='gallery-reveal--sub-container'>
				<div className='gallery-reveal--images'>
					<div className='gallery-reveal--img reveal-left'>
						<img src='/images/gallery/gallery-reveal-left.png' alt='' />
					</div>
					<div className='gallery-reveal--img reveal-right'>
						<img src='/images/gallery/gallery-reveal-right.png' alt='' />
					</div>
				</div>

				<div className='gallery-reveal--content'>
					<h4>
						She’s a wife, a help-mate. Thank you for following, <span>I love you with an everlasting love!</span>
					</h4>
					<div>
						<svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
							<g clipPath='url(#clip0_569_3148)'>
								<path
									d='M16.5 3.5C15.6267 3.5 14.7655 3.70332 13.9844 4.09385C13.2034 4.48438 12.524 5.0514 12 5.75C11.2916 4.80553 10.3041 4.10787 9.17719 3.75586C8.0503 3.40385 6.84122 3.41532 5.72122 3.78866C4.60121 4.16199 3.62707 4.87826 2.93676 5.836C2.24646 6.79375 1.875 7.94441 1.875 9.125C1.875 15.8656 11.2406 21.1812 11.6344 21.4062C11.7459 21.469 11.872 21.5013 12 21.5C12.1281 21.5022 12.2544 21.4698 12.3656 21.4062C14.0903 20.398 15.708 19.2169 17.1937 17.8812C20.4656 14.9375 22.125 11.9937 22.125 9.125C22.125 7.63316 21.5324 6.20242 20.4775 5.14752C19.4226 4.09263 17.9918 3.5 16.5 3.5Z'
									fill='#FFF690'
								/>
							</g>
							<defs>
								<clipPath id='clip0_569_3148'>
									<rect width='24' height='24' fill='white' transform='translate(0 0.5)' />
								</clipPath>
							</defs>
						</svg>
						<p>Your husband.</p>
					</div>
				</div>
			</div>
		</div>
	)
}

export default GalleryReveal
